import { INDICATRIX_NAMESPACE, INDICATRIX_COMMITS, INDICATRIX_DISPATCHS } from '@/store/contracts'
import { get, save, schemaOf, deleteMany } from "@/api/indicatrix.js"
import { findProjectViewFilter } from '@/utils/indicatrix-filter'
/*
{
    indicatrixs:{
        view1: {
            title: '',
            columnDefs:[],
            data:{
                _id: <value>,
                _ext:{
                    top_project:{$id:<value>},
                    view_id:"",
                    spec_id:""
                },
               rowData: [...] 
            }
            
        },
        ...
    }
}
*/
const STATUS = {
    clean: 'clean',
    ready: 'ready',
    edit: 'edit',
}
function initState(state) {
    //已经加载的指标数据
    state.indicatrixs = {}
    //修改的指标数据
    state.changedViews = []
    //标记要删除的指标数据
    state.recycleIndicatrixs = []
    //数据采集方案
    state.viewSchema = null
    //当前的项目工程id
    state.topProjectId = null
    state.status = STATUS.clean
}

const state = {}
initState(state)
const getters = {
    hasChangedData(state) {
        return state.changedViews.length > 0
    },
    views(state) {
        if (state.viewSchema) {
            return state.viewSchema['指标表']
        }
    },
    isOpened(state) {
        return !!state.topProjectId
    }
}
function assertChanged(state, op) {
    if (state.changedViews.length) {
        
        throw (`有未保存的数据，不能执行此操作(${op})！(请先调用CLEAN({force:true}))`)
    }
}
function assertOpened(state, op) {
    if (getters.isOpened(state)) {
        
        throw (`当前项目已打开，不能执行此操作(${op})！(请先调用CLOSE)`)
    }
}
function assertMustOpen(state, op) {
    if (!getters.isOpened(state)) {
        
        throw (`项目未打开，不能执行此操作(${op})！`)
    }
}
function assertClean(state, op) {
    if (state.status !== STATUS.clean) {
        throw (`当前状态(${state.status})不能执行此操作(${op})！(请先调用CLEAN({force:true}))`)
    }
}
function assertTopProjectId(topProjectId, op) {
    if (state.topProjectId !== topProjectId) {
        throw (`项目id不匹配(当前为${state.topProjectId}，目标为${topProjectId}),不能执行此操作(${op}`)
    }
}
const mutations = {

    [INDICATRIX_COMMITS.INIT]: function (state, { topProjectId }) {
        assertClean(state, 'INIT')
        state.topProjectId = topProjectId

        state.status = STATUS.ready

    },
    [INDICATRIX_COMMITS.EDIT]: function (state, { viewId, rowData }) {
        // const activeTable = state.indicatrixs[viewId]
        // if(activeTable){
        //     if(activeTable && activeTable.setValue){
        //         activeTable.setValue(rowId, field, value)
        //     }else{
        //         throw(`当前view:${viewId} 不可编辑`)
        //     }
        // }else{
        //     throw(`无法找到view:${viewId}`)
        // }
        const data = state.indicatrixs[viewId].data
        data.rowData = rowData
        if (state.changedViews.indexOf(viewId) === -1) {
            state.changedViews.push(viewId)
        }

        state.status = STATUS.edit
    },
    [INDICATRIX_COMMITS.SET_VIEW]: function (state, { viewId, viewTitle, data }) {
        /** data=
        * {
        *      columnDefs:[],
        *      data:{
        *          _id:xx,
        *          _ext:{
        *              top_project:{}
        *              view:{}
        *          },
        *          rowData:[]
        *      }
        * }
        */
        if (!viewTitle) {
            viewTitle = viewId
        }
        data.title = viewTitle
        state.indicatrixs[viewId] = data
    },
    [INDICATRIX_COMMITS.PERSISTENT]: function (state, { viewId, data }) {
        /** data=
        * {
        *          _id:xx,
        *          _ext:{
        *              top_project:{}
        *              view:{}
        *          },
        *          rowData:[]
        * }
        */
        const viewItem = state.indicatrixs[viewId]
        if (viewItem) {
            viewItem.data = data
            const idx = state.changedViews.indexOf(viewId)
            if (idx > -1) {
                state.changedViews.splice(idx, 1)
            }
        } else {
            throw ('未找到viewId数据：' + viewId)
        }
    },
    [INDICATRIX_COMMITS.SET_SCHEMA]: function (state, { schema }) {
        state.viewSchema = schema
    },
    [INDICATRIX_COMMITS.CLEAN]: function (state, options) {
        if (!options || !options.force) {
            assertChanged(state, INDICATRIX_COMMITS.CLEAN)
        }
        initState(state)
        state.status = STATUS.clean
    },
    [INDICATRIX_COMMITS.RECYCLE]: function (state, ids) {
        if(ids instanceof Array){
            state.recycleIndicatrixs.push.apply(state.recycleIndicatrixs,ids)
        }else{
            state.recycleIndicatrixs.push(ids)
        }
        
        state.status = STATUS.edit
    }
}
function buildViewData(topProjectId, viewId, rowData) {
    return {
        _ext: {
            top_project: { $id: topProjectId },
            view: { $id: viewId }
        },
        rowData
    }
}
function buildViewItem(viewTitle, data) {
    /** data=
     * {
     *          _id:xx,
     *          _ext:{
     *              top_project:{}
     *              view:{}
     *          },
     *          rowData:[]
     * }
     */
    return { title: viewTitle, data }
}
async function loadAndCommitSchema(topProjectId, commit) {
    let schema
    try {
        schema = await schemaOf(topProjectId).then(r => r.data)
    } catch (error) {
        // TODO
    }
    if (schema) {
        commit(INDICATRIX_COMMITS.SET_SCHEMA, { schema })
        return true
    }
    return false
}
const actions = {
    [INDICATRIX_DISPATCHS.OPEN]: async function ({ commit, state }, { topProjectId }) {
        assertOpened(state)
        commit(INDICATRIX_COMMITS.INIT, { topProjectId })
        const schemaLoaded = await loadAndCommitSchema(state.topProjectId, commit)
        return { schemaLoaded }
    },
    [INDICATRIX_DISPATCHS.LOAD_SCHEMA]: async function ({ commit, state },options) {
        assertMustOpen(state, INDICATRIX_DISPATCHS.LOAD_SCHEMA)
        let {topProjectId} = options||{}
        if(!topProjectId){
            topProjectId = state.topProjectId
        }else{
            assertTopProjectId(topProjectId)
        }
        
        return await loadAndCommitSchema(state.topProjectId, commit)
    },
    [INDICATRIX_DISPATCHS.CLOSE]: async function ({ commit, state }, options) {
        commit(INDICATRIX_COMMITS.CLEAN, options)
    },
    [INDICATRIX_DISPATCHS.LOAD]: async function ({ commit, state }, { topProjectId, viewId }) {
        assertMustOpen(state, INDICATRIX_DISPATCHS.LOAD)
        if(!topProjectId){
            topProjectId = state.topProjectId
        }else{
            assertTopProjectId(topProjectId, INDICATRIX_DISPATCHS.LOAD)
        }
        
        let viewData = state.indicatrixs[viewId]
        if (!viewData) {
            if (state.changedViews.length && state.changedViews.indexOf(viewId) > -1) {
                assertChanged(state, INDICATRIX_DISPATCHS.LOAD)
            }

            const filters = findProjectViewFilter({ topProjectId, viewId })
            const result = await get(filters).then(r => r.data);
            /**result=
             * {
             *      columnDefs:[],
             *      data:{
             *          _id:xx,
             *          _ext:{
             *              topProjectId:xx
             *              viewId:xx
             *          },
             *          rowData:[]
             *      }
             * }
             */
            if (result) {
                commit(INDICATRIX_COMMITS.SET_VIEW, { viewId, data: result })
                viewData = state.indicatrixs[viewId]
            }
        }

        return viewData

    },
    [INDICATRIX_DISPATCHS.SAVE]: async function ({ commit, state }) {
        if(state.recycleIndicatrixs.length){
            await deleteMany(state.recycleIndicatrixs)
            state.recycleIndicatrixs.length = 0
        }

        if (state.changedViews.length) {
            const changedData = []

            state.changedViews.forEach(viewId => {
                changedData.push(
                    state.indicatrixs[viewId].data
                )
            });
            
            const saved = await save(changedData).then(r =>r.data)
            
            if (saved && saved.length) {
                saved.forEach(data => {
                    const viewId = data._ext.viewId
                    commit(INDICATRIX_COMMITS.PERSISTENT, { viewId, data })
                });
            }
        }

    },
    [INDICATRIX_DISPATCHS.BUILD_VIEW_DATA]: async function ({ commit, state }, { topProjectId, viewId, rowData }) {
        /** 返回
           * {
         *      data:{
         *          _id:xx,
         *          _ext:{
         *              top_project:{}
         *              view:{}
         *          },
         *          rowData:[]
         *      }
         * }
         */
        const data = buildViewData(topProjectId, viewId, rowData)
        return { data }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}